import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Language as LinkIcon } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  linkPreview: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    marginTop: 8,
    padding: 10,
    borderRadius: 8,
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    textDecoration: "none",
    color: "inherit",
  },
  linkPreviewIcon: {
    marginTop: 2,
    color: "#666",
  },
  linkPreviewContent: {
    minWidth: 0,
  },
  linkPreviewTitle: {
    fontSize: 13,
    fontWeight: 500,
    overflowWrap: "anywhere",
  },
  linkPreviewUrl: {
    fontSize: 12,
    color: "#666",
    overflowWrap: "anywhere",
  },
}));

export const extractFirstUrl = (text = "") => {
  const urlMatch = text.match(/https?:\/\/[^\s]+/i);
  return urlMatch ? urlMatch[0] : null;
};

export const getLinkPreviewData = (text = "") => {
  const url = extractFirstUrl(text);
  if (!url) return null;

  try {
    const parsedUrl = new URL(url);
    const path = parsedUrl.pathname && parsedUrl.pathname !== "/" ? parsedUrl.pathname : "";
    const subtitle = `${parsedUrl.hostname}${path}`.slice(0, 120);

    return {
      url,
      title: parsedUrl.hostname.replace(/^www\./i, ""),
      subtitle,
    };
  } catch (error) {
    return null;
  }
};

const LinkPreview = ({ url, title, subtitle, className }) => {
  const classes = useStyles();

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={className || classes.linkPreview}
    >
      <LinkIcon className={classes.linkPreviewIcon} />
      <div className={classes.linkPreviewContent}>
        <div className={classes.linkPreviewTitle}>{title}</div>
        <div className={classes.linkPreviewUrl}>{subtitle}</div>
      </div>
    </a>
  );
};

export default LinkPreview;
